import { createStore, compose, combineReducers, applyMiddleware } from 'redux';
import thunk from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialStateSideBar = 'responsive';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const changeStateSideBar = (state = initialStateSideBar, { type, ...rest }) => {
  switch (type) {
    case 'setStateSideBar':
      return rest.sidebarShow
    default:
      return state
  }
}

const changeStateAlert = (state = {}, { type, ...rest }) => {
  switch (type) {
    case 'setStateAlert':
      return rest.alert
    default:
      return state
  }
}

const changeStateGeneralServices = (state = {}, { type, ...rest }) => {
  switch (type) {
    case 'setStateGeneralServices':
      return rest.generalServices
    default:
      return state
  }
}

const changeStateSelectsPrecios = (state = {}, { type, ...rest }) => {
  switch (type) {
    case 'setStateSelectsPrecios':
      return rest.stateSelectsPrecios
    default:
      return state
  }
}

const changeStateAuth = (state = {}, { type, ...rest }) => {
  switch (type) {
    case 'setStateAuth':
      return { ...state, ...rest }
    case 'setStateFinishAuth':
      return { ...rest }
    default:
      return state
  }
}

const changeStatePermissions = (state = {}, { type, ...rest }) => {
  switch (type) {
    case 'setStatePermissions':
      return rest.permissions
    default:
      return state
  }
}


const persistConfig = {
  key: 'persist',
  storage,
  whiteList: ['idUsuario', 'nombre', 'tipoUsuario', 'avatar', 'token', 'permissionsMenu']
}


const persistPermissionsConfig = {
  key: 'persistPermissions',
  storage,
  whiteList: ['permissions']
}

const reducers = combineReducers({
  auth: persistReducer(persistConfig, changeStateAuth),
  sidebarShow: changeStateSideBar,
  alert: changeStateAlert,
  generalServices: changeStateGeneralServices,
  stateSelectsPrecios: changeStateSelectsPrecios,
  permissions: persistReducer(persistPermissionsConfig, changeStatePermissions),
})


export const store = createStore(reducers, composeEnhancers(
    applyMiddleware( thunk )
))

export const persistor = persistStore(store);
